import { Link } from "react-router-dom";
import ButtonCSCLed from "shared/Button/ButtonCSCLed";
import Received_Coin_Icon from "images/rewards/Received_Coin_Icon.gif";

interface ProofOfPurchaseReceivedProps {
    receiptNumber: string;
    handleUploadPOP: () => void;
    emailMarketing: string;
    rewardsUpload?: React.RefObject<HTMLHeadingElement>;
  }

  const ProofOfPurchaseReceived = ({
    receiptNumber,
    handleUploadPOP,
    emailMarketing,
    rewardsUpload,
  }: ProofOfPurchaseReceivedProps) => {
    return (
      <div className="w-full">
        <h2
          style={{ fontFamily: 'Poppins, sans-serif' }}
          ref={rewardsUpload}
          className="pt-mobile font-medium p-6 text-xl text-green-800 sm:text-3xl md:text-2xl"
        >
          Proof of Purchase Received!
        </h2>
        <div className="flex flex-col lg:flex-row -mt-5">
          <div className="lg:w-2/3 xs:w-full p-4 px-6">
            <div className="mb-3 line-height-desktop md:line-height-mobile mt-mobile">
              <p className="mobile_mb">
                We have received your proof of purchase and are processing it now.
              </p>
              <p className="mobile_mb">
                Your proof of purchase number is: <b>{receiptNumber}</b>
              </p>
              <p className="mobile_mb">
                It may take 1-2 business days before your reward points appear in your account.
              </p>
              <p className="mobile_mb">
                Should you have any questions, please do not hesitate to reach out to{" "}
                <Link to={`mailto:${emailMarketing}`} className="text-csccolor">
                  {emailMarketing}
                </Link>
              </p>
              <p className="mobile_mb">
                Thank you for supporting CSC LED!
              </p>
              <p>The CSC LED Team</p>
            </div>
            <div className="form-group btn-mt-mobile">
              <div className="w-full md:w-3/4">
                <ButtonCSCLed
                  type="submit"
                  className="capitalize"
                  onClick={handleUploadPOP}
                >
                  Click here to upload another
                </ButtonCSCLed>
              </div>
            </div>
          </div>
          <div className="lg:w-1/3 mt-mobile xs:w-full order-first lg:order-last rewardsCoinIcon-mt">
            <img
              className="object-contain h-80 rewards-coin"
              src={Received_Coin_Icon}
              alt="Rewards Coin Icon"
            />
          </div>
        </div>
      </div>
    );
  };
  
  export default ProofOfPurchaseReceived;